export default __webpack_public_path__ + "static/media/Q9.c0ef766d.jpg";